/**
 * Single source of truth for supported cities and the default city.
 *
 * `value` is the Ahamove city_id (matches `_id`/`service_city_id` returned by
 * the `city_detail` API). `slug` drives the static SEO routes (`/[city]`,
 * `/[city]/[category]`) — the app flow itself is city-less and resolves
 * city_id from the saved address cookie.
 *
 * To open a new city: add ONE entry here. SEO pages, sitemap sections and
 * city detection all derive from this list — no other code changes needed.
 */

export interface City {
  label: string;
  value: string; // Ahamove city_id
  slug: string; // URL slug for SEO pages
}

export const CITIES: City[] = [
  { label: 'Hà Nội', value: 'HAN', slug: 'ha-noi' },
  { label: 'Đà Nẵng', value: 'DAD', slug: 'da-nang' },
  { label: 'Hồ Chí Minh', value: 'SGN', slug: 'ho-chi-minh' },
  { label: 'Tam Kỳ', value: 'VCL', slug: 'tam-ky' },
  { label: 'Đồng Nai', value: 'DNI', slug: 'dong-nai' },
  { label: 'Hải Dương', value: 'HDG', slug: 'hai-duong' },
];

/**
 * The ONE default city used everywhere a city cannot be resolved
 * (no address cookie, unknown coordinates, crawler traffic).
 * Được chốt trong SITEMAP_RESTRUCTURE_PLAN.md — không thêm fallback khác.
 */
export const DEFAULT_CITY_ID = 'SGN';
export const DEFAULT_CITY_SLUG = 'ho-chi-minh';

export const DEFAULT_CITY: City = CITIES.find(
  (c) => c.value === DEFAULT_CITY_ID
)!;

export function findCityBySlug(slug?: string | null): City | null {
  if (!slug) return null;
  return CITIES.find((c) => c.slug === slug) ?? null;
}

export function findCityById(cityId?: string | null): City | null {
  if (!cityId) return null;
  return CITIES.find((c) => c.value === cityId) ?? null;
}
